// frontend/src/DesignTab/MiniPie.tsx
import React from "react";

export type MiniPieSlice = {
  value: number;
  color: string;
};

export const MiniPie: React.FC<{
  size?: number;
  strokeWidth?: number;
  slices: MiniPieSlice[];
}> = ({ size = 16, strokeWidth = 5, slices }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  const total = slices.reduce((sum, s) => sum + s.value, 0);
  if (total <= 0) return null;

  let offset = 0;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <g transform={`rotate(-90 ${size / 2} ${size / 2})`}>
        {slices.map((s, i) => {
          const length = (s.value / total) * circumference;
          const dasharray = `${length} ${circumference - length}`;
          const dashoffset = -offset;
          offset += length;

          return (
            <circle
              key={i}
              cx={size / 2}
              cy={size / 2}
              r={radius}
              fill="none"
              stroke={s.color}
              strokeWidth={strokeWidth}
              strokeDasharray={dasharray}
              strokeDashoffset={dashoffset}
              strokeLinecap="butt"
            />
          );
        })}
      </g>
    </svg>
  );
};
